export default __webpack_public_path__ + "static/media/slide-6.6f983114.jpeg";